export class PopupDialogObject {
	public static create(options: PopupDialogOptions): PopupDialogObject {
		return new PopupDialogObject(
			options.success,
			options.dialogClass,
			options.title,
			options.trackMsgPrefix,
			options.description,
			options.listings,
			options.actions,
			options.disableClose,
			options.showSpinner,
			options.anchorLink,
			options.requestId
		);
	}
	constructor(
		public success: boolean,
		public dialogClass: string,
		public title: string,
		public trackMsgPrefix: string,
		public description: string,
		public listings: Array<any>,
		public actions: Array<PopupDialogAction>,
		public disableClose = false,
		public showSpinner = false,
		public anchorLink: any,
		public requestId: string
	) { }
}

export interface PopupDialogOptions {
	success: boolean;
	dialogClass: string;
	title: string;
	trackMsgPrefix: string;
	description: string;
	listings: Array<any>;
	actions: Array<PopupDialogAction>;
	disableClose?: boolean;
	showSpinner?: boolean;
	anchorLink?: any;
	requestId?: string;
}

export class PopupDialogAction {
	public static create(options: PopupDialogActionOptions): PopupDialogAction {
		return new PopupDialogAction(
			options.label,
			options.reload,
			options.description,
			options.url,
			options.unresolvedUrl,
			options.params,
			options.type,
			options.portfolioId,
			options.actionClass,
			options.config
		);
	}
	constructor(
		public label: string,
		public reload: boolean,
		public description?: string,
		public url?: string,
		public unresolvedUrl?: string,
		public params?: string | string[],
		public type?: string,
		public portfolioId?: string,
		public actionClass?: string,
		public config: string = 'MM'
	) { }
}

export interface PopupDialogActionOptions {
	label: string;
	reload: boolean;
	description?: string;
	url?: string;
	unresolvedUrl?: string;
	params?: string | string[];
	type?: string;
	portfolioId?: string;
	actionClass?: string;
	config?: string;
}
